import { defineStore } from 'pinia';
import { WINNERS_REQUEST_INTERWAL } from '~/utils/constants';
import { parsePreloadWinners, parseWinner } from '~/utils/ss/winners';
import { useStoreRoot } from '../abstract/root';
import { useStoreCurrencyMenu } from '../strapi/currencyMenu';
import { softswiss } from '../transport/softswiss';
import type { ISsWinners, TSsWinnersResponse, ISsWinnersSlider } from '~/types/softswiss/ssWinners';
import type { IHttpRequestOptions } from '~/types/transport/http';

export const useStoreTopWinners = defineStore('topWinners', {
  state: () => ({
    winnersList: [] as ISsWinners[],
    intervalId: NaN,
    requestPromise: null as Promise<any> | null,
  }),
  getters: {
    topWinners(state): ISsWinnersSlider[] {
      let winnersList = state.winnersList;
      if (useStoreRoot().isEstonianLicense) {
        const isFiatCurrency = useStoreCurrencyMenu().isFiatCurrency;
        winnersList = state.winnersList.filter((item) => isFiatCurrency(item.round.currency));
      }
      return winnersList.map((winner) => parseWinner(winner));
    },
  },
  actions: {
    fetchData() {
      if (!this.requestPromise) {
        const path = usePlatform().isDesktop
          ? '/api/cf/stats/winners/top/desktop'
          : '/api/cf/stats/winners/top/mobile';

        this.requestPromise = softswiss()
          .get({ path, force: true } as IHttpRequestOptions)
          .finally(() => (this.requestPromise = null));
      }

      return this.requestPromise;
    },
    /**
     * function for loaded winners and filter by user games
     **/
    async load(): Promise<void> {
      const preloadWinners = (await this.fetchData()) as TSsWinnersResponse;

      if (preloadWinners && Array.isArray(preloadWinners)) {
        this.winnersList = parsePreloadWinners(preloadWinners);
      }
    },
    subscribeWinners(): void {
      if (this.intervalId) {
        this.unsubscribeWinners();
      }

      this.intervalId = window.setInterval(() => {
        this.load();
      }, WINNERS_REQUEST_INTERWAL);
    },
    unsubscribeWinners(): void {
      window.clearInterval(this.intervalId);
    },
  },
});
